import { useTranslation } from 'react-i18next';
import { UAParser } from 'ua-parser-js';
import LaunchMyBusinessTools from '../../components/LaunchMyBusinessTools/LaunchMyBusinessTools';
import { useTrackOnPageLoad } from '../../utils/analytics';
import Faq from './components/Faq/Faq';
import FeatureBannerAiQuality from './components/FeatureBannerAiQuality';
import FeatureBannerHowItWorks from './components/FeatureBannerHowItWorks/FeatureBannerHowItWorks';
import FeatureBannerMoreForFree from './components/FeatureBannerMoreForFree';
import FeatureBannerSimplePrompts from './components/FeatureBannerSimplePrompts/FeatureBannerSimplePrompts';
import Gallery from './components/Gallery/Gallery';
import HeroBanner from './components/HeroBanner/HeroBanner';
import NavBar from './components/NavBar/Navbar';
import { PromotionsBanner } from './components/PromotionsBanner/PromotionsBanner';
import StatsSection from './components/StatsSection/StatsSection';
import StickyCTA from './components/StickyCTA/StickyCTA';
import Testimonials from './components/Testimonials/Testimonials';

const CORE_PRODUCT_ID = 'PRD-WRFGWR7PP';

const LogomakerGenAiPage = () => {
    const { browser, os, device } = UAParser();
    const { t } = useTranslation();

    useTrackOnPageLoad('Product Viewed', {
        label: 'Product page view',
        core_product_id: CORE_PRODUCT_ID,
        variant: '',
    });

    useTrackOnPageLoad('Homepage Device Details', {
        label: 'Homepage:Device Details',
        core_product_id: CORE_PRODUCT_ID,
        browser,
        os,
        deviceType: device.type ?? 'desktop',
    });
    return (
        <>
            <HeroBanner />
            <NavBar />
            <FeatureBannerAiQuality />
            <FeatureBannerSimplePrompts />
            <FeatureBannerMoreForFree />
            <FeatureBannerHowItWorks />
            <Gallery />
            <StatsSection />
            <Testimonials />
            <Faq />
            <PromotionsBanner />
            <LaunchMyBusinessTools
                header={t('Vista Logos > Launch My Business Tools > Heading.value')}
                subheader={t(
                    'Vista Logos > Logomaker landing page > Launch My Business Tools > Description.value',
                )}
                businessTools={[
                    'businessNameGenerator',
                    'brandKit',
                    'wixWebsites',
                    'socialMediaTemplates',
                    'design',
                ]}
                trackingCategory="Design Services"
            />
            <StickyCTA />
        </>
    );
};

export default LogomakerGenAiPage;
